"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Icons_1 = require("../../Icons");
var Layouts_1 = require("../../Layouts");
var Localization_1 = require("../../Localization");
var Theme_1 = require("../../Theme");
var Flags_styles_1 = require("./Flags.styles");
exports.default = (function (_a) {
    var Flags = _a.Flags;
    // Order alphabetically with the situation response flags last
    var flags = Flags.filter(function (f) { return f.Type !== "SituationResponseNotOkay" && f.Type !== "SituationResponseOkay"; })
        .sort(function (a, b) { return (a.Type < b.Type) ? -1 : (a.Type > b.Type) ? 1 : 0; })
        .concat(Flags.filter(function (f) { return f.Type === "SituationResponseNotOkay" || f.Type === "SituationResponseOkay"; }));
    var iconProps = {
        Height: "24px",
        Width: "24px",
    };
    var buildFlagIcon = function (flagType) {
        switch (flagType) {
            case "Privacy": return React.createElement(Icons_1.LockIcon, __assign({}, iconProps));
            case "MedicalHold": return React.createElement(Icons_1.HeartIcon, __assign({}, iconProps));
            case "AccountHold": return React.createElement(Icons_1.AccountIcon, __assign({}, iconProps));
            case "IncidentHold": return React.createElement(Icons_1.AlertTriangleIcon, __assign({}, iconProps));
            case "VisitorHold": return React.createElement(Icons_1.UserIcon, __assign({}, iconProps));
            case "SituationResponseOkay": return React.createElement(Icons_1.ShieldPositiveIcon, __assign({}, iconProps));
            case "SituationResponseNotOkay": return React.createElement(Icons_1.ShieldNegativeIcon, __assign({}, iconProps));
        }
    };
    var buildColor = function (flagType) {
        switch (flagType) {
            case "SituationResponseOkay": return Theme_1.Color.Green.Lighter;
            case "SituationResponseNotOkay": return Theme_1.Color.Red.Regular;
            default: return Theme_1.Color.Orange.Lighter;
        }
    };
    var buildCaption = function (flagType) {
        switch (flagType) {
            case "Privacy": return Localization_1.strings.Flags_Label_Privacy;
            case "MedicalHold": return Localization_1.strings.Flags_Label_MedicalHold;
            case "AccountHold": return Localization_1.strings.Flags_Label_AccountHold;
            case "IncidentHold": return Localization_1.strings.Flags_Label_IncidentHold;
            case "VisitorHold": return Localization_1.strings.Flags_Label_VisitorHold;
            case "SituationResponseOkay": return Localization_1.strings.Flags_Label_SituationResponseOkay;
            case "SituationResponseNotOkay": return Localization_1.strings.Flags_Label_SituationResponseNotOkay;
        }
    };
    var buildDescriptiveText = function (flagType, humanReadableFlagType, title) {
        if (flagType === "SituationResponseOkay") {
            var result = "" + Localization_1.strings.formatString(Localization_1.strings.Flags_Label_SituationResponseTooltip, Localization_1.strings.Flags_Label_SituationResponseOkay);
            if (title) {
                result += ": " + title;
            }
            return result;
        }
        if (flagType === "SituationResponseNotOkay") {
            var result = "" + Localization_1.strings.formatString(Localization_1.strings.Flags_Label_SituationResponseTooltip, Localization_1.strings.Flags_Label_SituationResponseNotOkay);
            if (title) {
                result += ": " + title;
            }
            return result;
        }
        if (title) {
            return humanReadableFlagType + ": " + title;
        }
        return humanReadableFlagType;
    };
    return (React.createElement(Layouts_1.Stack, { Flow: "column", Gap: "xxSmall", ContentSizing: "max-content", JustifyContent: "start" },
        React.createElement(Flags_styles_1.FlagDiv, { Color: Theme_1.Color.StarRezBrandColors.WhiteRegular },
            React.createElement(Icons_1.FlagIcon, __assign({}, iconProps)),
            React.createElement(Flags_styles_1.P, null, Localization_1.strings.Label_Flags)),
        flags.map(function (_a) {
            var Type = _a.Type, Title = _a.Title;
            var caption = buildCaption(Type);
            var descriptiveText = buildDescriptiveText(Type, caption, Title);
            return (React.createElement(Flags_styles_1.FlagDiv, { key: Type, Color: buildColor(Type), title: descriptiveText, "aria-label": descriptiveText },
                buildFlagIcon(Type),
                React.createElement(Flags_styles_1.P, null, caption)));
        })));
});
